import api from "../../../../lib/api";
import { ICreatePickupRequest, IEditPickupRequestPayload, IPickupRequestListSearch } from "../../../../types/operations/pickupRequestInterface";

export const createPickupRequestApi = async (data: ICreatePickupRequest) => {
  return await api.post(`/operations/pickup-request`, data);
};

export const getPickupRequestListApi = async (data: IPickupRequestListSearch) => {
  return await api.get(`/operations/pickup-request/${data.page}/${data.pageLimit}?search=${data?.search ?? ""}`);
};

export const getBranchDropdownByPincode = async (data: {pincode: string | number}) => {
  return await api.post(`branch/request-branch`, data);
};

export const getPickupRequestDataByIdApi = async (id: string) => {
  return await api.get(`/operations/pickup-request/${id}`)
}

export const editPickupRequestDataByIdApi = async (payload: IEditPickupRequestPayload) => {
  return await api.put(`/operations/pickup-request/${payload.id}`, payload.data);
};
